<template>
  <div class="product-list">
    <div style="text-align: left; padding: 1rem;height: 5vh;">
      <a href="https://shop.cobetter.com/">
        <img
          src="https://cdn.shopifycdn.net/s/files/1/0666/9939/5371/files/Cobetter_Logo_9fd190f7-9986-4030-9f87-4c63051fd3b8.png?v=1666179714"
          alt=""
          style="max-width: 130px; height: auto"
        />
      </a>
    </div>
    <el-card
      class="box-card"
      v-if="!showDiv"
      shadow="never"
    >
      <div slot="header">
        <a href="https://shop.cobetter.com/pages/custom-single-use-manifolds">
          <i
            class="el-icon-back"
            style="font-size: 1rem;font-weight: 400;color: #1e1e1e;"
          > Custom Single-Use Manifolds</i>
        </a>
      </div>
      <div class="product-list-row">
        <span
          v-for="(product, index) in productList"
          :key="index"
          class="product-item"
        >
          <span
            class="box-hover"
            @mouseover="handleMouseOver(index)"
            @mouseout="handleMouseOut(index)"
            @click="addProduct(product)"
          >
            <img
              :src="product.image.src"
              class="box-img"
            />
            <div class="box-icon">
              <div class="Icon svg">
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  popper-class="productListPopover"
                >
                  <template #reference>
                    <div class="popover-reference">
                      <!-- 这里放置要触发 Popover 的内容 -->
                      <el-button
                        style="display: none"
                        slot="reference"
                        :ref="`el-icon-plus-button${index}`"
                        class="el-icon-plus-button"
                      ><i
                          class="el-icon-plus"
                          style="color: #1e1e1e; font-weight: 600"
                        ></i></el-button>
                    </div>
                  </template>
                  <div class="popover-content">
                    <!-- 这里放置 Popover 内部的内容 -->
                    Add Product
                  </div>
                </el-popover>
              </div>
            </div>
          </span>
          <!-- <div class="product-info" @click="setShowDiv(true)"> -->
          <div class="product-info">
            <span>{{ product.title }}</span>
          </div>
        </span>
      </div>
    </el-card>

    <el-card
      class="box-card box-product-detail-card"
      v-if="showDiv"
      shadow="never"
    >
      <div slot="header">
        <i
          class="el-icon-back"
          @click="setShowDiv(false)"
          style="font-size: 1rem;font-weight: 400;"
        > List
        </i>
      </div>
      <div class="product-list-row">
        <div
          class="card-content"
          v-if="selectedProductList[selectedBlockIndex]"
        >
          <el-row
            :gutter="10"
            style="padding: 1rem 0"
          >
            <el-col
              :xs="12"
              :sm="12"
              :md="12"
              :lg="12"
            >

              <img
                :src="
                  selectedProductList[selectedBlockIndex].selectedVariant
                    .image_src
                "
                class="box-img"
              />
              <span
                v-if="parseInt(selectedProductList[selectedBlockIndex].selectedVariant.compare_at_price) > parseInt(selectedProductList[selectedBlockIndex].selectedVariant.price)"
                style="position: absolute;
                      left: 0px;
                      background-color: #D9001B;
                      color: #fff;
                      padding: 2px 5px;"
              >
                -{{ Math.round((selectedProductList[selectedBlockIndex].selectedVariant.compare_at_price
                    - selectedProductList[selectedBlockIndex].selectedVariant.price)
                    / selectedProductList[selectedBlockIndex].selectedVariant.compare_at_price * 100) }}
                %</span>
            </el-col>
            <el-col
              :xs="12"
              :sm="12"
              :md="12"
              :lg="12"
            >
              <div class="itemDetails">
                <div class="ProductSummary">
                  <div class="ProductItemDetail">
                    <div class="detailsText">
                      <span class="name isLarge">
                        {{ selectedProductList[selectedBlockIndex].title }}
                        <span>
                          {{selectedProductList[selectedBlockIndex].selectedVariant.title}}
                        </span>
                      </span>
                      <div class="description"></div>
                      <div
                        class=""
                        style="margin-top: 1rem;"
                      >
                        <span
                          v-if="parseInt(selectedProductList[selectedBlockIndex].selectedVariant.compare_at_price) > parseInt(selectedProductList[selectedBlockIndex].selectedVariant.price)"
                          style="text-decoration:line-through;color:#7F7F7F;font-size: 12px;"
                        >
                          ${{
                          selectedProductList[selectedBlockIndex]
                            .selectedVariant.compare_at_price
                        }}
                        </span>
                        <span
                          class="price"
                          style=""
                        >
                          ${{ selectedProductList[selectedBlockIndex].selectedVariant.price}}
                        </span>
                      </div>

                    </div>
                  </div>
                  <div class="showMoreDetails"></div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 产品详细connector -->
          <div class="product-detail-radio">
            <div
              class="product-detail-radio-item"
              v-if="selectedProductList[selectedBlockIndex].options[0]"
            >
              <div style="width: 100%">
                {{ selectedProductList[selectedBlockIndex].options[0].name }} :
              </div>
              <el-radio-group
                size="mini"
                v-model="radio1"
                @change="selectProductRadio(radio1)"
              >
                <el-radio
                  v-for="(value, i) in selectedProductList[selectedBlockIndex]
                    .options[0].values"
                  :key="i"
                  :label="value"
                  border
                >{{ value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div
              class="product-detail-radio-item"
              v-if="selectedProductList[selectedBlockIndex].options[1]"
            >
              <div style="width: 100%">
                {{ selectedProductList[selectedBlockIndex].options[1].name }} :
              </div>
              <el-radio-group
                size="mini"
                v-model="radio2"
                @change="selectProductRadio(radio2)"
              >
                <el-radio
                  v-for="(value, i) in selectedProductList[selectedBlockIndex]
                    .options[1].values"
                  :key="i"
                  :label="value"
                  border
                >{{ value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div
              class="product-detail-radio-item"
              v-if="selectedProductList[selectedBlockIndex].options[2]"
            >
              <div style="width: 100%">
                {{ selectedProductList[selectedBlockIndex].options[2].name }} :
              </div>
              <el-radio-group
                size="mini"
                v-model="radio3"
                @change="selectProductRadio(radio3)"
              >
                <el-radio
                  v-for="(value, i) in selectedProductList[selectedBlockIndex]
                    .options[2].values"
                  :key="i"
                  :label="value"
                  border
                >{{ value }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>

    </el-card>
  </div>
</template>

<script>
  import {
    productListByCollectionId,
    metafieldsByProductId,
  } from '@/api/shopify';
  import { mapState, mapMutations } from 'vuex';

  export default {
    name: 'ProductList',
    props: {
      collectionId: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        productList: [],
        option1: '',
        option2: '',
        option3: '',
        radio1: '',
        radio2: '',
        radio3: '',
      };
    },
    watch: {
      collectionId: {
        handler(newVal) {
          this.$nextTick(() => {
            if (this.collectionId) {
              productListByCollectionId(this.collectionId).then((res) => {
                this.productList = res.data.list;
              });
            }
          });
        },
      },
      selectedBlockIndex: {
        handler(newVal) {
          this.$nextTick(() => {
            if (newVal != -1) {
              this.option1 = this.radio1 =
                this.selectedProductList[newVal].selectedVariant.option1;
              this.option2 = this.radio2 =
                this.selectedProductList[newVal].selectedVariant.option2;
              this.option3 = this.radio3 =
                this.selectedProductList[newVal].selectedVariant.option3;
            }
          });
        },
      },
    },
    computed: {
      ...mapState([
        'selectedProductList',
        'showDiv',
        'selectedBlockIndex',
        'productOriginLeft',
        'productOriginTop',
      ]),
    },
    methods: {
      ...mapMutations([
        'addSelectedProductList',
        'setShowDiv',
        'changeSelectedProductList',
        'setSelectedBlockIndex',
      ]),
      // 添加产品到设计页
      addProduct(product) {
        // 这个深度拷贝对一些特定类型无法拷贝
        let tempProduct = JSON.parse(JSON.stringify(product));
        let varaintIndex = 0;
        // 添加SelectVariant字段
        let productRes = this.addSelectVariantIntoSelectedProduct(
          varaintIndex,
          tempProduct
        );

        // 添加旋转角度
        productRes['rotation'] = 0;
        productRes['style'] = { transform: 'rotate(0deg)' };
        // 添加产品的坐标
        productRes['productOriginLeft'] = this.productOriginLeft;
        productRes['productOriginTop'] = this.productOriginTop;

        // 获取元字段
        let custom_zoom = 1;
        let custom_points = [];
        metafieldsByProductId(tempProduct.id).then((res) => {
          res.data.list.forEach((item) => {
            if (!item.value) {
              return;
            }
            if (item.key == 'custom_zoom') {
              custom_zoom = item.value;
            }
            if (item.key.startsWith('custom_point')) {
              let pointArr = item.value.split(',');
              custom_points.push({
                width_ratio: pointArr[0],
                height_ratio: pointArr[1],
              });
            }
          });
          productRes['custom_zoom'] = custom_zoom;
          productRes['custom_points'] = custom_points;
          this.addSelectedProductList(productRes);
        });
      },

      // 选择产品的变体
      selectProductRadio(value) {
        // 选择参数，根据传入的参数赋值各个option（根据api，每个变体字段有option1，option2，option3三种）
        this.selectedProductList[this.selectedBlockIndex].variants.forEach(
          (element, variantIndex) => {
            if (value == element.option1) {
              this.option1 = value;
              this.changeOptionHandler();
            }
            if (value == element.option2) {
              this.option2 = value;
              this.changeOptionHandler();
            }
            if (value == element.option3) {
              this.option3 = value;
              this.changeOptionHandler();
            }
          }
        );
      },
      // 产品参数改变监听事件
      changeOptionHandler() {
        this.selectedProductList[this.selectedBlockIndex].variants.forEach(
          (element, variantIndex) => {
            if (
              this.option1 == element.option1 &&
              (element.option2 == null
                ? true
                : this.option2 == element.option2) &&
              (element.option3 == null ? true : this.option3 == element.option3)
            ) {
              let product = JSON.parse(
                JSON.stringify(this.selectedProductList[this.selectedBlockIndex])
              );
              let productRes = this.addSelectVariantIntoSelectedProduct(
                variantIndex,
                product
              );

              this.changeSelectedProductList(productRes);
            }
          }
        );
      },
      // 给产品增加已选择变体的字段selectedVariant，传给vuex并返回
      addSelectVariantIntoSelectedProduct(variantIndex, product) {
        let temp = {
          variantIndex: variantIndex,
          title: product.variants[variantIndex].title,
          id: product.variants[variantIndex].id,
          price: product.variants[variantIndex].price,
          compare_at_price: product.variants[variantIndex].compare_at_price,
          option1: product.variants[variantIndex].option1,
          option2: product.variants[variantIndex].option2,
          option3: product.variants[variantIndex].option3,
          image_src: '',
        };

        let image_index = -1;
        product.images.forEach((element, i) => {
          if (product.variants[variantIndex].image_id == element.id) {
            image_index = i;
          }
        });
        if (image_index != -1) {
          temp.image_src = product.images[image_index].src;
        }
        product.selectedVariant = temp;
        return product;
      },
      handleMouseOver(id) {
        this.$refs[`el-icon-plus-button${id}`][0].$el.style.display =
          'inline-block';
      },
      handleMouseOut(id) {
        this.$refs[`el-icon-plus-button${id}`][0].$el.style.display = 'none';
      },
    },
  };
</script>



<style scoped>
  .el-card {
    border-top: 0;
  }

  .box-card {
    height: 100vh;
  }

  .box-product-detail-card {
    text-align: left;
    height: 100%;
  }

  .product-item .box-img {
    width: 7rem;
    height: 7rem;
    max-width: 7rem;
  }

  .card-content .box-img {
    max-width: 15rem;
  }
  .product-info {
    margin-left: 1rem;
    text-align: center;
    float: left;
  }

  .product-info:hover {
    text-decoration: underline;
  }

  .product-info span {
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.125rem;
    overflow: hidden;
    padding-top: 0.5rem;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .product-list-row {
    overflow-y: auto;
    overflow-x: hidden;
    height: 80vh;
    padding: 0 0 1rem 1rem;
    /* border-bottom: 1px solid #cfcfcf; */
  }
  .product-item {
    display: flex;
    cursor: pointer;
    padding: 0.5rem 0;
    align-items: center;
  }

  .el-icon-back {
    cursor: pointer;
    line-height: 1.5rem;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .card-header {
    padding: 0 1rem;
    text-align: left;
  }

  .header-title {
    font-size: 0.75rem;
    line-height: 1.7rem;
  }

  .card-content {
    padding: 0 1rem;
  }

  .name.isLarge {
    color: #484848;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.375rem;
  }

  .box-hover {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 7rem;
    height: 7rem;
    float: left;
  }

  .box-hover:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(139, 139, 139, 0.1); /* 半透明背景颜色 */
    z-index: 1;
  }

  .box-icon {
    align-items: center;
    display: flex;
    justify-content: center;
    position: absolute;
  }

  .el-icon-plus-button {
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    opacity: 0.9;
    padding: 0.75rem;
    display: flex;
    position: absolute;
    left: -20px;
    top: -10px;
    z-index: 10;
  }

  .Icon {
    display: inline-block;
    position: relative;
  }

  .popover-reference {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 可以根据需要设置其他样式 */
  }

  .popover-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 可以根据需要设置其他样式 */
  }

  .product-detail-radio {
    margin: 2rem 1rem;
  }

  .product-detail-radio-item {
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1366px) {
    .product-item {
      width: 100%;
    }
  }

  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0px;
  }

  .product-detail-radio .el-radio {
    margin-top: 0.2rem;
    margin-right: 4px;
  }

  .el-radio__label {
    padding-left: 0px;
  }

  .product-detail-radio {
    margin: 0;
  }

  .el-radio--mini.is-bordered {
    padding: 6px 10px 0 0px;
  }

  .el-radio__label {
    padding-left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductList.vue